import React from 'react';
import styled from 'styled-components';

// Components
import Button from '../../Button/Button';

const DeletePreset = ({
  setOpenModal,
  data,
  deletePreset
}) => {
  return (
    <Container>
      <ActionContainer>
        <Button 
          size="lg" 
          variant="outlined" 
          onClick={() => setOpenModal(false)}
          style={{ marginRight: 16 }}>
          Cancel
        </Button>
        <Button 
          size="lg"
          variant="danger"
          onClick={() => deletePreset(data)}>
          Delete
        </Button>
      </ActionContainer>
    </Container>
  );
};

export default DeletePreset;

const Container = styled.div`

`

const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 36px;
`